import { isNullOrUndefined } from '@weft/utils';
import { useParams } from 'react-router-dom';

type ValidatedParams<Keys extends string[]> = {
  [key in Keys[number]]: string;
};

export function useValidatedParams<Keys extends string[] = []>(...keysToValidate: Keys): ValidatedParams<Keys> {
  const params = useParams();

  const validatedParams = {} as ValidatedParams<Keys>;

  keysToValidate.forEach(key => {
    if (isNullOrUndefined(params[key])) {
      throw new Error(`${key} is not defined`);
    }

    validatedParams[key as Keys[number]] = params[key] as string;
  });

  return validatedParams;
}